import { Controller } from "stimulus";

export default class extends Controller {
  handleChange(event) {
    const checkbox = event.target;
    if (!checkbox.matches("input[type='checkbox']")) return;

    const isRequired = checkbox.name.includes("[required_");
    const targetCheckboxName = checkbox.name.replace(isRequired ? "required_" : "captures_", isRequired ? "captures_" : "required_");
    const targetCheckbox = this.element.querySelector(`input[type="checkbox"][name='${targetCheckboxName}']`);

    if (!targetCheckbox) return;

    if (isRequired && checkbox.checked) {
      targetCheckbox.checked = true;
      targetCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
    } else if (!isRequired && !checkbox.checked) {
      targetCheckbox.checked = false;
      targetCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}
